import { Card } from '@material-ui/core'
import Alert from 'elements/Alert'
import { Button } from 'opensolar-ui'
import { useTranslate } from 'ra-core'
import React from 'react'

interface ProjectErrorModalProps {
  message: string
  onClose?: () => void
  buttonText?: string
  title?: string
  stylesOverride?: React.CSSProperties
}

const ProjectErrorModal: React.FC<ProjectErrorModalProps> = ({
  message,
  onClose,
  buttonText,
  title,
  stylesOverride = {},
}) => {
  const translate = useTranslate()

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        flexDirection: 'column',
        display: 'flex',
        WebkitFlexDirection: 'column',
        background: 'rgba(0, 0, 0, 0.5)',
        zIndex: 21,
        ...stylesOverride,
      }}
    >
      <div
        style={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Card style={{ width: '70%', maxWidth: 500, padding: 20 }}>
          <h2>{translate(title || 'Error')}</h2>
          <div>
            <Alert severity="error" options={{ style: { marginBottom: 15 } }}>
              {translate(message)}
            </Alert>
            {onClose && (
              <Button style={{ float: 'right' }} variant="contained" onClick={onClose}>
                <span>{translate(buttonText || 'OK')}</span>
              </Button>
            )}
          </div>
        </Card>
      </div>
    </div>
  )
}

export default ProjectErrorModal
